import React, { useState, useCallback, useEffect } from "react";
import AuctionLots from "../../components/auctionLots/AuctionLots";
import GoTopButton from "../../components/GoTopButton";
import { auctionV2ApiClient } from "../../auctions-list-page/AuctionApiClient";
import styles from "../items-for-sale/MyItemsForSale.module.scss";
const LocalStorageKey = "ObservedObjectsV1";
const WatchedItemsLimit = 100;
export function ObservedObjects({ strings, auctionUrl, sortOrders, defaultSortOrder, objectsTypes }) {
    const [selectedObjectType, setSelectedObjectType] = useState(null);
    const [sortOrder, setSortOrder] = useState(null);
    const getWatchedItems = useCallback(async () => {
        if (!selectedObjectType || !sortOrder)
            return {
                position: 1,
                items: [],
                total: -1, // Inform AuctionLots component that we're still loading data
            };
        const items = await auctionV2ApiClient.getWatchedItems(selectedObjectType, sortOrder.key);
        return {
            items,
            total: items.length,
            position: 1,
        };
    }, [selectedObjectType, sortOrder]);
    function onObjectsTypesChange(e) {
        const key = parseInt(e.target.value);
        if (key !== selectedObjectType) {
            setSortOrder(sortOrders.find(t => t.key == defaultSortOrder));
            setSelectedObjectType(key);
        }
    }
    function onSortOrderChange(e) {
        const key = parseInt(e.target.value);
        setSortOrder(sortOrders.find(t => t.key == key));
    }
    useEffect(() => {
        if (!selectedObjectType || !sortOrder)
            return;
        const storageData = {
            selectedObjectType,
            sortOrder,
        };
        localStorage.setItem(LocalStorageKey, JSON.stringify(storageData));
    }, [selectedObjectType, sortOrder]);
    useEffect(() => {
        var _a;
        const storageItem = localStorage.getItem(LocalStorageKey);
        if (!storageItem) {
            setSelectedObjectType(objectsTypes[0].key);
            setSortOrder((_a = sortOrders.find(x => x.key === defaultSortOrder)) !== null && _a !== void 0 ? _a : sortOrders[0]);
            return;
        }
        const storageData = JSON.parse(storageItem);
        setSelectedObjectType(storageData.selectedObjectType);
        setSortOrder(storageData.sortOrder);
    }, []);
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: styles.filtersRightFrame },
            React.createElement("div", { className: styles.selectList },
                React.createElement("label", null,
                    strings.observedObjects.objectsTypesLabel,
                    ":"),
                React.createElement("select", { value: selectedObjectType !== null && selectedObjectType !== void 0 ? selectedObjectType : 0, onChange: onObjectsTypesChange }, objectsTypes.map((itm) => (React.createElement("option", { key: itm.key, value: itm.key }, itm.value))))),
            React.createElement("div", { className: styles.selectList },
                React.createElement("label", null,
                    strings.observedObjects.sortOrderLabel,
                    ":"),
                React.createElement("select", { value: sortOrder === null || sortOrder === void 0 ? void 0 : sortOrder.key, onChange: onSortOrderChange }, sortOrders.map((itm) => (React.createElement("option", { key: itm.key, value: itm.key }, itm.value)))))),
        React.createElement(AuctionLots, { auctionUrl: auctionUrl, strings: strings.auctionLots, getItems: getWatchedItems, biddingDisabled: true, forceShowWatchItem: true, auctionStatus: 0, showOnlyActive: false, removeItemOnWatchedRemoved: true, saveItemPositionState: () => { }, itemsPerPageLimit: WatchedItemsLimit }),
        React.createElement(GoTopButton, { label: strings.auctionLots.auctionLot.backToTopButton })));
}
